// src/utils/searchTerms.js
export function tokenize(...parts) {
  const set = new Set();
  for (const s of parts) {
    String(s || "")
      .toLowerCase()
      .split(/[^\p{L}\p{N}]+/u) // unicode-aware: split on non letters/numbers
      .filter(Boolean)
      .forEach(t => set.add(t));
  }
  return Array.from(set);
}

const NYC_BOROUGHS = new Set([
  "manhattan", "brooklyn", "queens", "bronx", "staten island"
]);

function geoAliasTokens(cityRaw, stateRaw) {
  const city = String(cityRaw || "").trim().toLowerCase();
  const state = String(stateRaw || "").trim().toUpperCase();
  const out = new Set();

  // NYC (exact city names, common spellings, or any borough when state=NY)
  if (
    city === "new york" ||
    city === "new york city" ||
    city === "nyc" ||
    city === "n.y.c." ||
    (NYC_BOROUGHS.has(city) && state === "NY")
  ) {
    out.add("nyc");
  }
  // Keep borough token itself if present (useful filter)
  if (NYC_BOROUGHS.has(city) && state === "NY") {
    out.add(city); // "manhattan", "brooklyn", ...
  }

  // Long Island (by phrase or county names)
  if (
    state === "NY" &&
    (city.includes("long island") || city === "nassau" || city === "suffolk")
  ) {
    out.add("longisland");
    out.add("li");
  }

  // Baltimore
  if (city === "baltimore" && state === "MD") {
    out.add("baltimore");
    out.add("bmore");
  }

  // Annapolis
  if (city === "annapolis" && state === "MD") {
    out.add("annapolis");
  }

  // Ocean City, MD
  if (city === "ocean city" && state === "MD") {
    out.add("oceancity");
    out.add("ocmd");
  }

  return Array.from(out);
}

export function buildSearchTerms(ev = {}) {
  const bandTokens = Array.isArray(ev.bands)
    ? ev.bands.flatMap(b => tokenize(b?.bandname || b?.name || b))
    : [];

  // prefer explicit city/state; fall back to venue fields
  const city = ev.city || ev.venue_city;
  const state = ev.state || ev.venue_state;

  const aliases = geoAliasTokens(city, state);

  return tokenize(
    ev.title,
    ev.venue_name,
    ev.venue_internallink,
    city,
    state,
    ...bandTokens,
    ...aliases
  );
}
